interface Props {
    from: string;
    to: string;
    onChange: (from: string, to: string) => void;
}

const presets: { label: string; days: number }[] = [
    { label: "7d", days: 7 },
    { label: "30d", days: 30 },
    { label: "90d", days: 90 },
    { label: "1y", days: 365 },
];

const today = () => new Date().toISOString().slice(0, 10);
const daysAgo = (n: number) => new Date(Date.now() - n * 86_400_000).toISOString().slice(0, 10);

export function DateRangePicker({ from, to, onChange }: Props) {
    return (
        <div className="flex items-center gap-2 flex-wrap">
            {presets.map((p) => (
                <button
                    key={p.label}
                    onClick={() => onChange(daysAgo(p.days), today())}
                    className="text-xs px-3 py-1.5 rounded-md border border-okiru-muted/30 hover:border-okiru-accent transition"
                >
                    {p.label}
                </button>
            ))}
            <input
                type="date"
                value={from}
                onChange={(e) => onChange(e.target.value, to)}
                className="bg-okiru-panel border border-okiru-muted/30 rounded-md px-2 py-1 text-sm"
            />
            <span className="text-okiru-muted">→</span>
            <input
                type="date"
                value={to}
                onChange={(e) => onChange(from, e.target.value)}
                className="bg-okiru-panel border border-okiru-muted/30 rounded-md px-2 py-1 text-sm"
            />
        </div>
    );
}
